import { Check, Pencil } from "lucide-react"
import { langStore } from "@/stores/lang-store"

const groupEditModeBundle = {
  edit: {
    ko: "그룹 편집",
    en: "Edit Groups",
    es: "Editar grupos"
  },
  editing: {
    ko: "편집 중",
    en: "Editing",
    es: "Editando"
  },
  complete: {
    ko: "편집 완료",
    en: "Done",
    es: "Finalizar"
  }
}

const GroupEditModeButton = ({ isEditMode, onClick }) => {
  const { lang } = langStore()

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isEditMode}
      className={`group relative inline-flex shrink-0 items-center gap-2 rounded-xl border px-2 md:px-3.5 py-2 text-sm font-semibold transition-colors ${
        isEditMode
          ? "border-none bg-blue-50 text-blue-700 "
          : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-100"
      }`}
    >
      {isEditMode && (
        <svg className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
          <rect
            x="1"
            y="1"
            width="calc(100% - 2px)"
            height="calc(100% - 2px)"
            rx="11"
            fill="none"
            stroke="#3b82f6"
            strokeWidth="2"
            strokeDasharray="5 4"
            className="group-edit-border-svg"
          />
        </svg>
      )}

      <span className="relative inline-flex items-center">
        {isEditMode ? (
          <>
            <Pencil
              size={16}
              strokeWidth={2}
              className="transition-transform duration-300 group-hover:scale-0 group-hover:rotate-45"
              aria-hidden="true"
            />
            <Check
              size={16}
              strokeWidth={2}
              className="absolute scale-0 -rotate-45 transition-transform duration-300 group-hover:scale-100 group-hover:rotate-0"
              aria-hidden="true"
            />
          </>
        ) : (
          <Pencil size={16} strokeWidth={2} aria-hidden="true" />
        )}
      </span>

      <span className="relative min-w-14 hidden md:block">
        {isEditMode ? (
          <>
            <span className="transition-opacity duration-200 group-hover:opacity-0">
              {groupEditModeBundle.editing[lang]}
            </span>
            <span className="absolute inset-0 whitespace-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100">
              {groupEditModeBundle.complete[lang]}
            </span>
          </>
        ) : (
          groupEditModeBundle.edit[lang]
        )}
      </span>
    </button>
  )
}

export default GroupEditModeButton
